import { modifyCredits } from "../../api";
import { Button, NumberInput, Group, Textarea, Select } from "@mantine/core";
import { useForm } from "@mantine/form";
import { notifications } from "@mantine/notifications";
import { useState } from "react";
import { useTenantStore } from "./tenantStore";

export default function AddCreditsForm({ tenant }) {
  const [isLoading, setIsLoading] = useState(false);
  const updateTenantStore = useTenantStore((state) => state.updateTenant);
  
  const form = useForm({
    mode: "uncontrolled",
    initialValues: {
      credits: 0,
      note: "",
      creditType: "default",
      validDays: "31",
    },
  });

  return (
    <form
      onSubmit={form.onSubmit((values) => {
        setIsLoading(true);
        modifyCredits(tenant.id, values)
          .then((data) => {
            updateTenantStore(tenant.id, data); // Update global state with API response
            notifications.show({ title: "Credits added", color: "green" });
            setIsLoading(false);
          })
          .catch((error) => {
            notifications.show({
              title: "Failed to add credits",
              message: error.message,
              color: "red",
            });
            setIsLoading(false);
          });
      })}
    >
      <Group align="flex-end">
        <NumberInput
          label="Credits"
          {...form.getInputProps("credits")}
          key={form.key("credits")}
          radius="md"
        />

        <Select
          label="Type"
          {...form.getInputProps("creditType")}
          key={form.key("creditType")}
          radius="md"
          data={[{ value: "default", label: "Default" }]}
        />

        <Select
          label="Validity"
          {...form.getInputProps("validDays")}
          key={form.key("validDays")}
          data={[
            { value: "31", label: "31d" },
            { value: "92", label: "92d" },
            { value: "366", label: "366d" },
          ]}
          radius="md"
        />
      </Group>
      <Textarea
        label="Note"
        minRows={2}
        maxRows={5}
        autosize
        {...form.getInputProps("note")}
        key={form.key("note")}
      />
      <Button mt="sm" disabled={isLoading} type="submit">
        Apply
      </Button>
    </form>
  );
}
